<ng-select
  #select
  [items]="filterDropdown"
  [multiple]="true"
  bindLabel="value"
  [groupBy]="groupBy"
  [selectableGroup]="true"
  [selectableGroupAsModel]="false"
  [closeOnSelect]="false"
  [placeholder]="placeholder"
  (change)="filterSelected($event)"
  [(ngModel)]="selectedFilterVals"
  (clear)="unselectAllFiltersEvent.emit()"
  [searchable]="searchable"
  [searchFn]="customFilterSearch"
  [compareWith]="compare"
  [disabled]="disabled"
  [virtualScroll]="true"
  (close)="onClose()"
>
  <ng-template ng-header-tmp>
    <button
      (click)="unselectAllFiltersEvent.emit()"
      class="btn btn-sm filter-btn"
    >
      {{ buttonText }}
    </button>
    <button
      *ngIf="applyToFilter"
      (click)="this.applyFilters(select)"
      class="btn btn-sm filter-btn"
    >
      Apply
    </button>
  </ng-template>
  <ng-template
    ng-optgroup-tmp
    let-item="item"
    let-item$="item$"
    let-index="index"
  >
    <input
      id="itemField-{{ index }}"
      type="checkbox"
      [ngModel]="item$.selected"
    />
    {{ item[categoryAttribute] | uppercase }}
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-item$="item$"
    let-index="index"
  >
    <input
      id="itemValue-{{ index }}"
      type="checkbox"
      class="filter-dropdown-checkbox"
      [ngModel]="item$.selected"
    />{{ lodash.get(item, itemAttribute) }}
  </ng-template>
  <ng-template ng-multi-label-tmp let-items="items">
    <div
      class="ng-value"
      *ngFor="let item of items ? items.slice(0, numItemsShown) : []"
    >
      <span class="ng-value-label" [matTooltip]="item.subfield.name">
        {{
          item.subfield.name.length > 12
            ? (item.subfield.name | slice: 0:12) + "..."
            : item.subfield.name
        }}
      </span>
      <span
        class="ng-value-icon right filter-dropdown-select-value-icon"
        (click)="clearItemEvent.emit(item)"
        aria-hidden="true"
        >×</span
      >
    </div>
    <div class="ng-value" *ngIf="items.length > numItemsShown">
      <span class="ng-value-label"
        >{{ items.length - numItemsShown }} more...</span
      >
    </div>
  </ng-template>
</ng-select>
